var installedModules = {};
var moduleToHandlerMapping = {
	7819: {
		getter: () => (() => (__webpack_require__(6088))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shell/config",
	},
	5603: {
		getter: () => (() => (__webpack_require__(7610))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	4261: {
		getter: () => (() => (__webpack_require__(5699))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	6411: {
		getter: () => (() => (__webpack_require__(3393))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.5.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	6787: {
		getter: () => (() => (__webpack_require__(5689))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	7909: {
		getter: () => (() => (__webpack_require__(2867))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	2875: {
		getter: () => (() => (__webpack_require__(3620))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.5.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	2713: {
		getter: () => (() => (__webpack_require__(847))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@aca/core",
	},
	4843: {
		getter: () => (() => (__webpack_require__(8015))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	5055: {
		getter: () => (() => (__webpack_require__(6039))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	5380: {
		getter: () => (() => (__webpack_require__(436))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	157: {
		getter: () => (() => (__webpack_require__(1861))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/angular-fontawesome",
	},
	2773: {
		getter: () => (() => (__webpack_require__(4456))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	1401: {
		getter: () => (() => (__webpack_require__(7172))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	7261: {
		getter: () => (() => (__webpack_require__(9074))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	3096: {
		getter: () => (() => (__webpack_require__(7013))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@aca/ui",
	},
	6620: {
		getter: () => (() => (__webpack_require__(1134))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/pro-regular-svg-icons",
	},
	8724: {
		getter: () => (() => (__webpack_require__(559))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/pro-solid-svg-icons",
	},
	119: {
		getter: () => (() => (__webpack_require__(4106))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@aca/datetime",
	},
	2217: {
		getter: () => (() => (__webpack_require__(3835))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser/animations",
	},
	205: {
		getter: () => (() => (__webpack_require__(1147))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.25",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations/browser",
	},
	1624: {
		getter: () => (() => (__webpack_require__(6127))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^10.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@ngneat/until-destroy",
	},
	414: {
		getter: () => (() => (__webpack_require__(3236))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/api",
	},
	4032: {
		getter: () => (() => (__webpack_require__(7916))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/core",
	},
	9352: {
		getter: () => (() => (__webpack_require__(7604))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/semantic-conventions",
	},
	3638: {
		getter: () => (() => (__webpack_require__(260))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/exporter-metrics-otlp-http",
	},
	4162: {
		getter: () => (() => (__webpack_require__(9513))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/sdk-metrics",
	},
	3042: {
		getter: () => (() => (__webpack_require__(7304))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/resources",
	},
	9434: {
		getter: () => (() => (__webpack_require__(6880))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/exporter-trace-otlp-http",
	},
	9386: {
		getter: () => (() => (__webpack_require__(7982))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/instrumentation",
	},
	6272: {
		getter: () => (() => (__webpack_require__(755))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/instrumentation-xml-http-request",
	},
	3330: {
		getter: () => (() => (__webpack_require__(9989))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/sdk-trace-web",
	},
	2142: {
		getter: () => (() => (__webpack_require__(9402))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/sdk-trace-base",
	},
	792: {
		getter: () => (() => (__webpack_require__(8583))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shared/services",
	},
	4679: {
		getter: () => (() => (__webpack_require__(5675))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@aca/cookies",
	},
	6335: {
		getter: () => (() => (__webpack_require__(3213))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@fullstory/browser",
	},
	7660: {
		getter: () => (() => (__webpack_require__(1765))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shared/telemetry",
	},
	107: {
		getter: () => (() => (__webpack_require__(4926))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/dialog",
	},
	3202: {
		getter: () => (() => (__webpack_require__(4254))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/signalr",
	},
	4877: {
		getter: () => (() => (__webpack_require__(5157))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/menu",
	},
	4938: {
		getter: () => (() => (__webpack_require__(2223))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.7.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@ng-select/ng-select",
	},
	6933: {
		getter: () => (() => (__webpack_require__(1162))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/badge",
	},
	9567: {
		getter: () => (() => (__webpack_require__(3206))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/slide-toggle",
	}
};
var initialConsumes = [7819,5603,4261,6411,6787,7909,2875,2713,4843,5055,5380,157,2773,1401,7261,3096,6620,8724,119,2217,205,1624,414,4032,9352,3638,4162,3042,9434,9386,6272,3330,2142];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"660": [
		7660
	],
	"792": [
		7819,
		5603,
		4261,
		6411,
		6787,
		7909,
		2875,
		2713,
		4843,
		5055,
		5380,
		157,
		2773,
		1401,
		7261,
		3096,
		6620,
		8724,
		119,
		2217,
		205,
		1624,
		414,
		4032,
		9352,
		3638,
		4162,
		3042,
		9434,
		9386,
		6272,
		3330,
		2142
	],
	"818": [
		792,
		4679,
		6335
	],
	"915": [
		107,
		3202,
		4877,
		4938,
		6933,
		9567
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}